import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { memo, useCallback, useState } from 'react';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { is_paid_tariff } from 'console/billing/billing-utils';
import { savePrivateSettings } from 'entities/device.private_settings/model/actions';
import { closePrivateSettings } from 'entities/device.private_settings/model/slice';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { UniversalDialog } from 'console/dialogs/universal';
import { Button } from '@mui/material';
import { PersonalParamsUpdater } from 'entities/device.private_settings/ui/index';
import { privateDeviceName, privateDeviceNote, } from 'entities/device.private_settings/lib';
export function is_open_private_params_dialog(state) {
    return state.private_params_dialog.open;
}
export function device_id_for_updating_dialog(state) {
    return state.private_params_dialog?.device_id ?? null;
}
export const PersonalParamsUpdateDialog = memo(function PersonalParamsUpdateDialog() {
    const isProUser = useAppSelector(is_paid_tariff);
    const isOpen = useAppSelector(is_open_private_params_dialog);
    const device_id_for_setting = useAppSelector(device_id_for_updating_dialog);
    const redux_private_name = useAppSelector(privateDeviceName(device_id_for_setting));
    const redux_private_note = useAppSelector(privateDeviceNote(device_id_for_setting));
    const [privateNote, setPrivateNote] = useState(redux_private_note);
    const [privateName, setPrivateName] = useState(redux_private_name);
    const sendNewSettings = useAction(savePrivateSettings);
    const onSetPrivateName = useCallback((value) => {
        setPrivateName(value);
    }, [setPrivateName]);
    const onSetPrivateNote = useCallback((value) => {
        setPrivateNote(value);
    }, [setPrivateNote]);
    const onCloseV2 = useAction(closePrivateSettings);
    const _onClose = useCallback(() => onCloseV2(), []);
    const onSavePrivateConfigs = useCallback(() => {
        if (device_id_for_setting != null) {
            sendNewSettings(device_id_for_setting, privateName, privateNote);
        }
        onCloseV2();
    }, [privateName, privateNote]);
    return (_jsx(ErrorBoundary, { children: _jsx(UniversalDialog, { open: isOpen, onClose: _onClose, title: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u044B\u0445 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u043E\u0432", maxWidth: "sm", footer: _jsx(Button, { disabled: !isProUser, onClick: onSavePrivateConfigs, children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C" }), children: _jsx(ErrorBoundary, { children: _jsx(PersonalParamsUpdater, { onSetIndividualDeviceNote: onSetPrivateNote, onSetIndividualDeviceName: onSetPrivateName, show_paid_option: true, device_id: device_id_for_setting }) }) }) }));
});
